import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { noop, isEmpty } from 'lodash';
import classnames from 'classnames';
import { ExpandableContainer } from '@unite-us/app-components';
import DetailDescription from 'common/display/SingleItemDetails/dashboard/DetailDescription';
import DetailSummaryForm from 'common/display/SingleItemDetails/DetailSummaryForm';
import ClientNeedEditForm from 'common/display/SingleItemDetails/ClientNeedEditForm';
import usePersonConditions from 'src/common/hooks/usePersonConditions';
import { useFeatureFlag } from 'common/hooks';
import '../stylesheets/detail-view.scss';
import addLineBreaks from '../../../utils/addLineBreaks';
import ModalEditForm from '../../../modal/ModalEditForm';

function DetailSummary(props) {
  const {
    className,
    description,
    editable,
    submit,
    descriptionTitle,
    descriptionEditSubtitle,
    descriptionSubtitle,
    item,
    referral,
  } = props;

  const [currentClientNeedsIds, setCurrentClientNeedsIds] = useState(referral?.case?.person_condition_ids);
  const clientNeedFeatureFlag = useFeatureFlag('crtb-1788-client-needs');
  const personId = referral?.case?.person?.id;
  const clientNeeds = usePersonConditions(personId, false);

  const selectedNeeds = clientNeeds.filter((need) => currentClientNeedsIds?.includes(need.id))
    .map((need) => need.name).join(', ') || '';
  const showClientNeedField = clientNeedFeatureFlag && clientNeeds.length > 0 && !isEmpty(selectedNeeds);

  return (
    <div className={classnames('detail-summary', 'detail-info__summary', className)}>
      { showClientNeedField && (
        <div className="row detail-info__client-need-container">
          <div className="col-md-10">
            <div className="detail-info__client-need">
              <ExpandableContainer
                id="detail-description-expandable"
                header="Associated needs"
                collapsedHeight="70px"
              >
                <p className="no-margin">{addLineBreaks(selectedNeeds)}</p>
              </ExpandableContainer>
            </div>
          </div>
          <div className="col-md-2">
            <ModalEditForm
              id="edit-client-need-modal"
              buttonId="edit-client-need"
              header="Edit Associated Needs"
              size="large"
              showEdit={editable}
              labelText="Edit"
            >
              <ClientNeedEditForm
                needIds={currentClientNeedsIds}
                clientNeeds={clientNeeds}
                submit={submit}
                referral={referral}
                onUpdate={setCurrentClientNeedsIds}
                personId={personId}
              />
            </ModalEditForm>
          </div>
        </div>
      )}
      <div className="row detail-info__description-container">
        <div className="col-md-10">
          <DetailDescription
            id="detail-description-expandable"
            title={descriptionTitle}
            subtitle={descriptionSubtitle}
            description={description}
          />
        </div>
        <div className="col-md-2">
          <ModalEditForm
            id="edit-detail-description-modal"
            buttonId="edit-detail-description"
            header="Edit"
            size="large"
            showEdit={editable}
            labelText="Edit"
          >
            <DetailSummaryForm
              descriptionSubtitle={descriptionEditSubtitle}
              detailObj={item}
              notes={description}
              submit={submit}
            />
          </ModalEditForm>
        </div>
      </div>
    </div>
  );
}

DetailSummary.propTypes = {
  className: PropTypes.string,
  editable: PropTypes.bool,
  description: PropTypes.string,
  descriptionEditSubtitle: PropTypes.node,
  descriptionSubtitle: PropTypes.node,
  descriptionTitle: PropTypes.string,
  item: PropTypes.shape({
    _meta: PropTypes.shape({
      _type: PropTypes.string,
    }),
  }).isRequired,
  submit: PropTypes.func,
  referral: PropTypes.object,
};

DetailSummary.defaultProps = {
  className: '',
  editable: true,
  description: '',
  descriptionEditSubtitle: null,
  descriptionSubtitle: null,
  descriptionTitle: 'Description',
  submit: noop,
  referral: null,
};

export default DetailSummary;
